import { call, put, takeLatest } from 'redux-saga/effects';
import { ActionType, getType } from 'typesafe-actions';
import { IBaseReservation, ILocalinaWidgetApi } from '../../interfaces';
import * as actions from './cancelReservation-actions';

function* fetchReservation(api: ILocalinaWidgetApi, action: ActionType<typeof actions.fetchReservation>) {
    try {
        const reservation: IBaseReservation = yield call(
            api.getReservation,
            action.payload.restaurantId,
            action.payload.token,
        );

        yield put(actions.setReservation(reservation));
    } catch (e) {
        yield put(actions.reservationError(e));
    }
}

function* cancelReservation(api: ILocalinaWidgetApi, action: ActionType<typeof actions.cancelReservation>) {
    try {
        yield call(api.cancelReservation, action.payload.restaurantId, action.payload.token);
        yield put(actions.cancelSuccess());
    } catch (e) {
        yield put(actions.reservationError(e));
    }
}

export default function* cancelReservationSaga(api: ILocalinaWidgetApi) {
    yield takeLatest(getType(actions.fetchReservation), fetchReservation, api);
    yield takeLatest(getType(actions.cancelReservation), cancelReservation, api);
}
